/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT_INSTITUTIONAL_CLAIMS_DISCREPANCY,
  payload: data,
});

// Loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING_INSTITUTIONAL_CLAIMS_DISCREPANCY,
  isLoading: value,
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};

// API to get Reabte Program List
export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

export const dispatchRebatePrograme = (data) => ({
  type: ActionTypes.GET_REBATE_PROGRAM_UNALLOACTED_BALANCE,
  payload: data,
});

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
    dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

// To get the defaut selection on the req screen when reopening the req screen
export const refreshInstitutionalClaimUnitTypeDiscrepancy = () => ({
  type: ActionTypes.REFRESH_INSTITUTIONAL_UNIT_TYPE_DISCREPANCY,
  payload: {},
});

export const setInstitutionalClaimsData = (data) => ({
  type: ActionTypes.GET_INSTITUTIONAL_CLAIMS_DISCREPANCY_SEARCH_RESULT,
  searchResult: data,
});

// API call for the result grid of the Institutional Claims unit tyoe
export const getInstitutionalClaimsDiscrepancyResultGrid =
  (values) => (dispatch) => {
    dispatch(setLoading(true));
    return axios
      .post(
        `${serviceEndPoint.INSTITUTIONAL_CLAIMS_DISCREPANCY_SEARCH_RESULT}`,
        values
      )
      .then((response) => {
        dispatch(setLoading(false));

        if (response.data?.institutionalClaimDiscrepancyGridVO.length === 0) {
          dispatch(showNoDataMessage());
        } else {
          return dispatch(
            setInstitutionalClaimsData(
              response.data?.institutionalClaimDiscrepancyGridVO
            )
          );
        }
      })
      .catch((response) => {
        dispatch(setLoading(false));
        dispatch(setInstitutionalClaimsData([]));
        return response;
      });
  };

// API call for the result grid of the Institutional Claims unit tyoe
export const getReferenceDataInstitutionalClaims = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.GET_REFERENCE_DATA}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch({
        type: ActionTypes.GET_REFERENCE_DATA_INSTITUTIONAL_CLAIMS,
        referenceData: response.data,
      });
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch([]);
      return response;
    });
};
export const refreshInstitutionalClaimUnitTypeDiscDetailScreen =
  () => (dispatch) => {
    dispatch(setInstitutionalClaimsData([]));
  };
